/**
 * @fileoverview POST handler for the "/apps/:app_group_id/settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdSettingsCacheKeys } from "./constants";
import type { PostAppsAppGroupIdSettingsProps, PostAppsAppGroupIdResult } from "./types";

export const postAppsAppGroupIdSettings = reactQueryMutationAdapter(
  appsAppGroupIdSettingsCacheKeys,
  (props: PostAppsAppGroupIdSettingsProps): Promise<PostAppsAppGroupIdResult> => {
    return fetch(`/apps/${props.app_group_id}/settings`, "PUT", props);
  }
);
